// extracted by mini-css-extract-plugin
export default {"stickyBox":"style_stickyBox__ZVgVO","slide-in-bottom":"style_slide-in-bottom__6CWt0"};